export function aboutAsset(filename: string): string {
  return `/static/images/web-ui/about/${filename}`;
}
